<template>
  <el-dialog
    class="dialog-wrapper"
    visible
    :show-close="false"
    @close="abortCreate"
  >
    <ContentHeader
      slot="title"
      :title="
        isModalEdit
          ? $t('familyTypes.edit.title')
          : $t('familyTypes.create.title')
      "
    />
    <ValidationObserver
      ref="recipientForm"
      v-slot="{ handleSubmit, invalid }"
    >
      <el-form
        ref="form"
        label-position="top"
      >
        <el-row
          :gutter="20"
          type="flex"
        >
          <el-col :span="8">
            <FormItem
              rules="required"
              :label="$t('familyTypes.create.family')"
            >
              <el-autocomplete
                v-model="familyName"
                style="width: 100%"
                :fetch-suggestions="familiesList"
                :trigger-on-focus="true"
                value-key="label"
                clearable
                placeholder=""
                @select="
                  (item) => {
                    formData.familyCode = item.value;
                  }
                "
              >
                <template slot-scope="{ item }">
                  <AutocompleteItem :item="item" />
                </template>
              </el-autocomplete>
            </FormItem>
          </el-col>
          <el-col :span="8">
            <FormItem
              rules="required"
              :label="$t('familyTypes.create.type')"
            >
              <el-select
                v-model="formData.type"
                placeholder=""
              >
                <el-option
                  v-for="familyType in FamilyTypes"
                  :key="familyType"
                  :value="familyType"
                  :label="familyType"
                />
              </el-select>
            </FormItem>
          </el-col>
        </el-row>

        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortCreate"
          >
            {{ $t('familyTypes.create.abort') }}
          </el-button>
          <el-button
            type="primary"
            native-type="submit"
            :disabled="invalid"
            @click.prevent="handleSubmit(createUpdateLocation)"
          >
            {{
              isModalEdit
                ? $t('familyTypes.edit.save')
                : $t('familyTypes.create.save')
            }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import { analysesApi } from '@/api';
  import { FamilyTypes } from '@/config/constants';
  import FormItem from '@/components/FormItem.vue';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import AutocompleteItem from '@/components/AutocompleteItem.vue';

  const defaultData = {
    familyCode: '',
    type: '',
  };

  export default {
    name: 'CreateEditLocation',
    components: {
      FormItem,
      ContentHeader,
      FormButtons,
      AutocompleteItem,
    },
    props: {
      initialData: { type: Object, default: () => defaultData },
      isModalEdit: { type: Boolean, default: false },
    },
    data() {
      return {
        formData: { ...defaultData },
        FamilyTypes,
        familyName: null,
      };
    },
    async created() {
      try {
        if (this.isModalEdit) {
          const { familyCode, type } = this.initialData;
          this.formData = {
            ...defaultData,
            familyCode,
            type,
          };
          if (familyCode) {
            const response = await analysesApi.getFamiliesAutocomplete(
              'familyCode',
              familyCode,
              false
            );
            this.familyName =
              response && response.data.length ? response.data[0].family : null;
          }
        }
      } catch (error) {
        this.$notify({
          showClose: true,
          type: 'error',
          message: error.response.data.error.message,
        });
      }
    },
    methods: {
      async createUpdateLocation() {
        try {
          if (this.isModalEdit) {
            await analysesApi.familyTypesPatch(
              this.initialData.id,
              this.formData
            );
          } else {
            await analysesApi.familyTypesCreate(this.formData);
          }
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.isModalEdit
              ? this.$t('familyTypes.edit.success')
              : this.$t('familyTypes.create.success'),
          });
          this.$emit('dialogClose', { success: true });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      abortCreate() {
        this.$emit('dialogClose', { success: false });
      },
      async familiesList(value, cb) {
        const response = await analysesApi.getFamiliesAutocomplete(
          'family',
          value || '',
          false
        );
        const families = response.data.map((c) => ({
          label: c.family,
          value: c.familyCode,
        }));
        cb(families);
      },
    },
  };
</script>
